import METHODOLOGYEXPERIENCE from 'data/mantechcar24/methodology-experience.json';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const MethodologyExperience: React.FC = () => {
  return (
    <div>
      <StyledRecharts className="methodology">
        <ResponsiveContainer height={180} width="99%" minWidth={400}>
          <BarChart data={METHODOLOGYEXPERIENCE} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 10 }}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            />
            <YAxis type="category" dataKey="exp" tickLine={false} width={120} />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-x"
            />

            <Bar dataKey="share" barSize={8} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default MethodologyExperience;
